import React, { useState } from 'react';
import { Navbar, Nav, Container, Button, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const getUserName = () => {
  return sessionStorage.getItem('userName') ?? "";
}

const Header = ({ onToggleSidebar }) => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(getUserName);

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('roleId');
    navigate('/login');
  };

  return (
    <Navbar bg="dark" variant="dark" sticky="top">
      <Container fluid>
        <Navbar.Brand href="/">
          <img
            alt=""
            src="favicon-32x32.png"
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Inventario Mezcal
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Button
          className="d-lg-none ms-auto"
          variant="outline-light"
          onClick={onToggleSidebar}
        >
          <i className="bi bi-list" />
        </Button>

        <div className="ms-auto d-none d-lg-flex align-items-center">
          <Badge bg="info" text="dark" className="me-2">
            Conectado como: {userName}
          </Badge>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;